import {
    LoginActionTypes,
    AppShellLoginState,
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    IS_LOGGED_IN,
    REGISTER_NEW_USER,
    SET_REDIRECT_URL,
    UNSET_REDIRECT_URL,
    SET_IS_REGISTERED_WITH_NEWSLETTER,
    UserLoginDataResponse,
    UserData,
    SessionTypes,
    LOGOUT,
    LOGOUT_SUCCESS,
    LOGOUT_FAILED,
    SET_RETURNING_USER,
    SET_DEFAULT_STATE,
    SET_LAUNCH_DARKLY_USER_INFO,
    UNBLOCK_USER_SUCCESS_ACTION,
} from './types';
import { get } from 'Common/utils/objectUtils';

// eslint-disable-next-line complexity
export const getUserDataFromResponse = (response: UserLoginDataResponse): UserData => {
    return {
        id: response.id || '',
        email: response.email || '',
        firstName: response.firstName || '',
        lastName: response.lastName || '',
        hashedEmail: response.hashedEmail || '',
        hashedId: response.hashedId || '',
        loginHash: response.loginHash || '',
        registeredAt: response.registeredAt || '',
        isBuyer: response.isBuyer || false,
        sessionType: response.sessionType || SessionTypes.unknown,
        deliveryData: {
            address1: response.address1 || '',
            address2: response.address2 || '',
            postalCode: response.postalCode || '',
            city: response.city || '',
            shippingCountry: response.shippingCountry || '',
            shippingCountryCode: response.shippingCountryCode || '',
            shippingCountryName: response.shippingCountryName || '',
        },
    };
};

export const defaultLoginState: AppShellLoginState = {
    isFetching: false,
    didInvalidate: false,
    didFinishOnce: false,
    isLoggedIn: false,
    shouldShowDataPolicyOverlay: false,
    isRegistered: false,
    isRegisteredWithNewsletter: false,
    isReturningUser: false,
    data: undefined,
    error: {},
};

// eslint-disable-next-line complexity
const LoginReducer = (state: AppShellLoginState = defaultLoginState, action: LoginActionTypes): AppShellLoginState => {
    switch (action.type) {
        case SET_DEFAULT_STATE: {
            return {
                ...defaultLoginState,
            };
        }
        case REGISTER_NEW_USER:
        case LOGIN:
        case LOGOUT:
        case IS_LOGGED_IN: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case LOGIN_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                isLoggedIn: !!get(action.payload, 'data.isLoggedIn', false),
                isRegistered: !!get(action.payload, 'data.isUserRegistered', false),
                data: getUserDataFromResponse(action.payload.data),
                didInvalidate: false,
                didFinishOnce: true,
            };
        }
        case LOGIN_FAILED: {
            return {
                ...state,
                isFetching: false,
                didFinishOnce: true,
                isLoggedIn: false,
                didInvalidate: true,
                error: get(action.payload, 'data.errors', action.payload),
                shouldShowDataPolicyOverlay: get(action.payload, 'data.shouldShowDataPolicyOverlay', false),
            };
        }
        case SET_REDIRECT_URL: {
            return {
                ...state,
                redirectUrl: get(action.payload, 'url', ''),
            };
        }
        case UNSET_REDIRECT_URL: {
            return {
                ...state,
                redirectUrl: '',
            };
        }
        case SET_IS_REGISTERED_WITH_NEWSLETTER: {
            return {
                ...state,
                isRegisteredWithNewsletter: true,
            };
        }
        case LOGOUT_SUCCESS: {
            return {
                ...defaultLoginState,
            };
        }
        case LOGOUT_FAILED: {
            return {
                ...state,
                didInvalidate: true,
                error: get(action.payload, 'data.errors', action.payload),
            };
        }
        case SET_RETURNING_USER: {
            return {
                ...state,
                isReturningUser: action.payload?.isReturningUser || false,
            };
        }
        case SET_LAUNCH_DARKLY_USER_INFO: {
            return {
                ...state,
                launchDarklyUserKey: action.payload.launchDarklyUserKey,
                journeyId: action.payload.journeyId,
            };
        }
        case UNBLOCK_USER_SUCCESS_ACTION.toString(): {
            return {
                ...state,
                shouldShowDataPolicyOverlay: false,
            };
        }
        default: {
            return state;
        }
    }
};

export default LoginReducer;
